import { render, staticRenderFns } from "./MeshDescriptor.vue?vue&type=template&id=60052da6"
import script from "./MeshDescriptor.vue?vue&type=script&lang=js"
export * from "./MeshDescriptor.vue?vue&type=script&lang=js"
import style0 from "./MeshDescriptor.vue?vue&type=style&index=0&id=60052da6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports